module.exports = __webpack_public_path__ + "static/lake4-3554c6ae9e83b6b39690743bd1c322b2.png";